export default {
    methods: {
        isMobile(){
            return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) <= 960;
        },
        cancelEvent(e) {
            e.preventDefault();
        },
    }
}